import script from "./footnote.vue?vue&type=script&setup=true&lang=js"
export * from "./footnote.vue?vue&type=script&setup=true&lang=js"

import "./footnote.vue?vue&type=style&index=0&id=1788b768&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1788b768"]])

export default __exports__